var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "social-share-bar",
      class: _vm.getVariant("social-share-bar")
    },
    [
      _c("p", [_vm._v(_vm._s(_vm.$t("share_text")))]),
      _c("button-twitter", { attrs: { article: _vm.article } }),
      _c("button-linkedin", { attrs: { article: _vm.article } }),
      _c("button-facebook", { attrs: { article: _vm.article } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d0f3285", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0f3285","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/share/social-share-bar.vue
// module id = 565
// module chunks = 82